import {
  IAbsenceRequestDTO,
  IAbsenceRequestParams,
  IAbsenceRequestResultDTO,
  IAbsenceStatusDTO,
  IApproverDTO,
  ICreateAbsenceRequestDTO,
  IScheduledAbsenceDTO,
} from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult } from 'src/api/types';
import { SortDirectionEnums } from 'src/shared/enums';
import { getAxiosParams } from 'src/shared/utils';

export default class AbsenceRepository extends ESSRepository {
  private static readonly baseRoute = '/absences';
  private static readonly apiURL = AbsenceRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (params?: IAbsenceRequestParams): Promise<IAbsenceRequestDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IAbsenceRequestDTO>>(
        AbsenceRepository.apiURL,
        getAxiosParams(params),
      );
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public create = async (payload: ICreateAbsenceRequestDTO): Promise<IAbsenceRequestResultDTO> => {
    try {
      const { data } = await http.post<IAbsenceRequestResultDTO>(`${AbsenceRepository.apiURL}/requests`, payload);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public cancelAbsence = async (notificationIds: number[]): Promise<IAbsenceRequestDTO[]> => {
    try {
      const { data } = await http.delete<{ absenceRequestInformation: IAbsenceRequestDTO[] }>(
        `${AbsenceRepository.apiURL}/cancellation`,
        getAxiosParams({ notificationIds }),
      );

      return data.absenceRequestInformation;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getApprovers = async (): Promise<IApproverDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IApproverDTO>>(`${AbsenceRepository.apiURL}/approvers`);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getStatuses = async (): Promise<IAbsenceStatusDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IAbsenceStatusDTO>>(`${AbsenceRepository.apiURL}/statuses`);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getScheduledAbsences = async (params?: {
    sortDirection?: SortDirectionEnums;
  }): Promise<IScheduledAbsenceDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IScheduledAbsenceDTO>>(
        `${AbsenceRepository.apiURL}/scheduledabsences`,
        getAxiosParams(params),
      );
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public validate = async (params: ICreateAbsenceRequestDTO): Promise<void> => {
    try {
      await http.get(`${AbsenceRepository.apiURL}/requests/validation`, getAxiosParams(params));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
